// Auto-generated file - DO NOT EDIT
// Generated at: 2026-10-14T21:31:38.703Z
// Source: D1 `verification_services` table (workers/sms-inbound/schema.sql)

export interface ServiceFaqItem {
  q: string;
  a: string;
}

export interface ServiceData {
  value: string;
  label: string;
  name: string;
  priceCents: number;
  metaTitle: string;
  metaDescription: string;
  introCopy: string;
  faq: ServiceFaqItem[];
}

export const SERVICES: ServiceData[] = [
  {
    "value": "discord-2fa-number",
    "label": "Discord 2FA Verification",
    "name": "Discord",
    "priceCents": 275,
    "metaTitle": "Discord SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant Discord SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited Discord verifications.",
    "introCopy": "Need a Discord verification code right now? Get an SMS verification number for Discord instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment Discord sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this Discord SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my Discord code?",
        "a": "Most codes arrive within seconds of Discord sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another Discord code?",
        "a": "Each payment covers exactly one code. If you need another Discord code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "facebook-verification-number",
    "label": "Facebook Verification",
    "name": "Facebook",
    "priceCents": 300,
    "metaTitle": "Facebook SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant Facebook SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited Facebook verifications.",
    "introCopy": "Need a Facebook verification code right now? Get an SMS verification number for Facebook instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment Facebook sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this Facebook SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my Facebook code?",
        "a": "Most codes arrive within seconds of Facebook sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another Facebook code?",
        "a": "Each payment covers exactly one code. If you need another Facebook code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "google-2fa-number",
    "label": "Google 2FA Verification",
    "name": "Google",
    "priceCents": 450,
    "metaTitle": "Google SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant Google SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited Google verifications.",
    "introCopy": "Need a Google verification code right now? Get an SMS verification number for Google instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment Google sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this Google SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my Google code?",
        "a": "Most codes arrive within seconds of Google sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another Google code?",
        "a": "Each payment covers exactly one code. If you need another Google code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "instagram-verification-number",
    "label": "Instagram Verification",
    "name": "Instagram",
    "priceCents": 350,
    "metaTitle": "Instagram SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant Instagram SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited Instagram verifications.",
    "introCopy": "Need an Instagram verification code right now? Get an SMS verification number for Instagram instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment Instagram sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this Instagram SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my Instagram code?",
        "a": "Most codes arrive within seconds of Instagram sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another Instagram code?",
        "a": "Each payment covers exactly one code. If you need another Instagram code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "otp-verification-number",
    "label": "OTP Verification",
    "name": "OTP",
    "priceCents": 100,
    "metaTitle": "OTP SMS Verification Code – Get Your Code Instantly",
    "metaDescription": "Get an instant SMS verification number for any OTP code and receive it in seconds. Pay per code or rent a private number for unlimited OTP verifications.",
    "introCopy": "Need an OTP verification code right now? Get an SMS verification number instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment it is sent. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this OTP SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my OTP code?",
        "a": "Most codes arrive within seconds of being sent. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another OTP code?",
        "a": "Each payment covers exactly one code. If you need another OTP code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "roblox-verification-number",
    "label": "Roblox Verification",
    "name": "Roblox",
    "priceCents": 150,
    "metaTitle": "Roblox SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant Roblox SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited Roblox verifications.",
    "introCopy": "Need a Roblox verification code right now? Get an SMS verification number for Roblox instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment Roblox sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this Roblox SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my Roblox code?",
        "a": "Most codes arrive within seconds of Roblox sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another Roblox code?",
        "a": "Each payment covers exactly one code. If you need another Roblox code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "telegram-verification-number",
    "label": "Telegram Verification",
    "name": "Telegram",
    "priceCents": 400,
    "metaTitle": "Telegram SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant Telegram SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited Telegram verifications.",
    "introCopy": "Need a Telegram verification code right now? Get an SMS verification number for Telegram instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment Telegram sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this Telegram SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my Telegram code?",
        "a": "Most codes arrive within seconds of Telegram sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another Telegram code?",
        "a": "Each payment covers exactly one code. If you need another Telegram code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "tiktok-verification-number",
    "label": "Tiktok Verification",
    "name": "TikTok",
    "priceCents": 250,
    "metaTitle": "TikTok SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant TikTok SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited TikTok verifications.",
    "introCopy": "Need a TikTok verification code right now? Get an SMS verification number for TikTok instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment TikTok sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this TikTok SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my TikTok code?",
        "a": "Most codes arrive within seconds of TikTok sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another TikTok code?",
        "a": "Each payment covers exactly one code. If you need another TikTok code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "tinder-verification-number",
    "label": "Tinder Verification",
    "name": "Tinder",
    "priceCents": 200,
    "metaTitle": "Tinder SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant Tinder SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited Tinder verifications.",
    "introCopy": "Need a Tinder verification code right now? Get an SMS verification number for Tinder instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment Tinder sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this Tinder SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my Tinder code?",
        "a": "Most codes arrive within seconds of Tinder sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another Tinder code?",
        "a": "Each payment covers exactly one code. If you need another Tinder code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  },
  {
    "value": "whatsapp-verification-number",
    "label": "Whatsapp Verification",
    "name": "WhatsApp",
    "priceCents": 500,
    "metaTitle": "WhatsApp SMS Verification Code – Get Your OTP Instantly",
    "metaDescription": "Get an instant WhatsApp SMS verification number and receive your one-time code in seconds. Pay per code or rent a private number for unlimited WhatsApp verifications.",
    "introCopy": "Need a WhatsApp verification code right now? Get an SMS verification number for WhatsApp instantly — pay once, receive your number immediately, and your one-time code will appear here automatically the moment WhatsApp sends it. For guaranteed privacy and unlimited codes on a number only you control, consider renting your own VIP private number instead.",
    "faq": [
      {
        "q": "Is this WhatsApp SMS verification free?",
        "a": "No — each code has a small one-time fee (shown above), charged from your account balance or a quick top-up. We do not limit you to a single shared free number, so delivery is faster and more reliable than our free generator."
      },
      {
        "q": "How long does it take to receive my WhatsApp code?",
        "a": "Most codes arrive within seconds of WhatsApp sending them. If nothing arrives within 20 minutes, your payment is automatically refunded to your balance."
      },
      {
        "q": "Can I reuse the same number for another WhatsApp code?",
        "a": "Each payment covers exactly one code. If you need another WhatsApp code, just request and pay again — you may be given the same number or a different one from our pool."
      },
      {
        "q": "Is the number private to me?",
        "a": "No, this number can be used by other people too — your code is matched to your specific request, so you will only ever see your own code. For a number only you can use, rent a VIP private number instead."
      }
    ]
  }
];
